import { useContext } from 'react';
import { ComposerContext } from '../ComposerContext';
export const useComposer = () => useContext(ComposerContext);
//# sourceMappingURL=useComposer.js.map